import React from 'react';
import { Col, Container, Label, Row, Table } from 'reactstrap';
import data from "../../assets/data/Progress/province.json";
import Apaexlinecolumn from './Charts/provinceapaexlinecolumn';


const provinceBreakdown = () => {
    const calculateColumnTotal = (columnName) => {
        return data.reduce((total, item) => total + (item[columnName] || 0), 0);
      };

    return (
        <div>
            <div className="pt-5">
                <Container>
                    <Row className="justify-content-center text-center progreport-content">
                        <Label className='title' >BREAKDOWN OF PATIENTS AIDED PER PROVINCE; PER AGE CATEGORY; PER EMPLOYMENT CATEGORY; TYPE OF HOSPITAL; TYPE OF SURGERY</Label>
                        <Label className='title pt-3 pb-3' >BREAKDOWN OF PATIENTS AIDED PER PROVINCE</Label>
                        {/* <Col md={1} /> */}
                        {/* <Col  md={10}><img src={ProvinceChart}  /></Col> */}
                        <Col  md={12}>
                            <Row>
                                <Col md={7}>
                                <div className="table-responsive">
                                    <Table className="table  mb-0">
                                    <thead className="table-light">
                                    <tr>
                                    <th>Province</th>
                                    <th>2014/2022</th>
                                    <th>2022/2023</th>
                                    <th>2023/2024</th>
                                    {/* <th>2022/2023</th> */}
                                    <th>Total</th>
                                    <th>%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.map((item, index) => (
                                    <tr key={index}>
                                        <td className="bold-column">{item.province}</td>
                                        <td>{item['2014/2022']}</td>
                                        <td>{item['2022/2023']}</td>
                                        <td>{item['2023/2024']}</td>
                                        {/* <td>{item['2022/2023']}</td> */}
                                        <td>{item.Total}</td>
                                        <td>{item.Percentage}</td>
                                    </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th className="bold-column">Total</th>
                                        <td className="bold-column">{calculateColumnTotal('2014/2022')}</td>
                                        <td className="bold-column">{calculateColumnTotal('2022/2023')}</td>
                                        <td className="bold-column">{calculateColumnTotal('2023/2024')}</td>
                                        {/* <td className="bold-column">{calculateColumnTotal('2022/2023')}</td> */}
                                        <td className="bold-column">{calculateColumnTotal('Total')}</td>
                                        <td className="bold-column">{calculateColumnTotal('Percentage')}</td>
                                    </tr>
                                    </tfoot>
                                    </Table>
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <Apaexlinecolumn dataColors='["--bs-danger","--bs-primary", "--bs-success", "--bs-info" ]'/>
                                </Col>
                            </Row>
                        </Col>
                        {/* <Col  md={1}/> */}
                    </Row>
                    <Label className='simple-content pt-3' >Our beneficiaries continued to be predominantly from the western province and in fact increasinglyso. It can be concluded that over 53% of applications had been from the Western Province. It is alsoto be noted that for the entire period under review the beneficiaries from the Northern and EasterProvinces have been respectively under 2%. The Uva Province too accounted for less than 5% of ourbeneficiaries.</Label>
                </Container>
            </div>
        </div>
    );
}

export default provinceBreakdown;
